import { v4 as uuidV4 } from 'uuid'
import { getCartEmailCookie } from '@mc/email-capture'
import { trackGoldStandardEvent, Product } from '@mc/track-event'
import {
  ActionTypes,
  FUNNEL_STATE_ID,
  KeyTypes,
  saveUserData,
} from '@mc/user-data'
import { getAccountEmailAsync } from '@mc/user-info'
import { CheckoutEvents } from '../../lib/constants'

interface PlansPageViewedEventProps {
  isLoggedIn: boolean
}

// MTECH-148: Google Enhanced Conversions API requires a FE track event: "Plans Page Viewed"
// for a corresponding BE event "Plans Page Viewed (BE)", which will "enhance" the revenue field
// with the expected revenue given by the Marketing Estimated Revenue model
//
// The email condition was removed so this event fires unconditionally regardless of whether
// the user has an email. Email is still included in the payload when available. This ensures
// the event count accurately reflects drop-off at the plans/price page rather than being
// artificially lowered by users who haven't gone through the email capture step.
// See: https://ourmasterclass.slack.com/archives/C0AG4SZGGQ0/p1775660660893599
export const trackPlansPageViewed = async ({
  isLoggedIn,
}: PlansPageViewedEventProps) => {
  const email = isLoggedIn ? await getAccountEmailAsync() : getCartEmailCookie()

  trackGoldStandardEvent(
    CheckoutEvents.EVENTS.PLANS_PAGE_VIEWED_GOLD_STANDARD,
    {
      ...(email && { email }),
      order_id: uuidV4(),
      revenue: 0,
      product: Product.CORE,
    },
  )
}

export const savePlansPageViewed = () => {
  saveUserData({
    key: KeyTypes.FUNNEL_STATE,
    id: FUNNEL_STATE_ID,
    actionType: ActionTypes.USER_VIEWED_PLANS,
    eventName: CheckoutEvents.EVENTS.PLANS_PAGE_VIEWED_GOLD_STANDARD,
  })
}
